import {
  Component,
  contentChild,
  contentChildren,
  Directive,
  effect,
  ElementRef,
  HostListener,
  Inject,
  inject,
  input,
  Renderer2,
  signal,
  TemplateRef,
  viewChild,
  DOCUMENT
} from '@angular/core';
import {NgTemplateOutlet} from "@angular/common";


@Directive({
  selector: '[wunDropdownItem]'
})
export class DropdownItemDirective {
  public readonly templateRef = inject<TemplateRef<HTMLDivElement>>(TemplateRef);
  divider = input(false)
}

@Directive({
  selector: '[wunDropdownTrigger]'
})
export class DropdownTriggerDirective {}

@Component({
  selector: 'wun-dropdown',
  imports: [
    NgTemplateOutlet
  ],
  templateUrl: './dropdown.component.html',
  styleUrl: './dropdown.component.scss'
})
export class DropdownComponent {

  trigger = viewChild<ElementRef<HTMLSpanElement>>('triggerElement');
  items = contentChildren(DropdownItemDirective);
  visible = signal(false)
  overrideClass = input<string>('');
  private el = inject(ElementRef)
  private dropDown = viewChild<ElementRef>('dropDown');
  protected readonly left = signal(0)
  protected readonly top = signal(0)
  containerClass = input<string>('')


  constructor(
    private element: ElementRef,
  ) {
    effect(() => {
      const show = this.visible();
      if (show) this.showDropdown();
      else this.hideDropDown();
    });
  }

  toggle() {
    this.visible.update(d => !d)
  }

  @HostListener('window:click', ['$event'])
  click(ev: Event) {
    if (this.el.nativeElement.contains(ev.target)) return;
    const t = ev.target as HTMLElement;
    if (this.visible() && !t.contains(this.el.nativeElement)) this.visible.set(false)
  }

  private showDropdown() {
    if (this.dropDown()) {
      this.getPosition();
    }
  }

  protected hideDropDown() {

  }

  private getPosition() {
    const _ = this.trigger()!.nativeElement!.getBoundingClientRect();
    this.left.set(_.left);
    this.top.set(_.height + _.top);
  }
}
